<script>
import { mapGetters } from "vuex";
import moment from "moment";
import RichText from "@/components/ui/RichText.vue";

export default {
  name: "Bahn1Updates",
  components: { RichText },
  computed: {
    ...mapGetters("bahn1", ["bahn1Updates", "lastUpdated"]),
    updateTexts() {
      return this.bahn1Updates
        ? this.bahn1Updates.Update.map(u => u.Text).filter(Boolean)
        : [];
    },
    standDate() {
      return this.lastUpdated
        ? moment(this.lastUpdated).format("DD.MM.YYYY")
        : "";
    }
  }
};
</script>

<template>
  <div class="updates" v-if="updateTexts.length">
    <div class="updates-meta">
      <span class="updates-badge">Aktualisiert</span>
      <span class="updates-stand">Stand: {{ standDate }}</span>
    </div>

    <h2>Updates zu BAHN 1</h2>

    <ul class="updates-list">
      <li v-for="(text, index) in updateTexts" :key="index">
        <RichText :markdown-text="text" />
      </li>
    </ul>
  </div>
</template>

<style scoped>
.updates-meta {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}
.updates-badge,
.updates-stand {
  font-family: "GeometriaMedium", sans-serif;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.6px;
  text-align: left;
}
.updates-badge {
  color: #bf360c;
  background-color: #fde5b4;
  border-radius: 4px;
  padding: 3px 6px;
}
.updates-stand {
  color: #1f2b37;
  background-color: #dddddd;
  border-radius: 4px;
  padding: 3px 6px;
}
h2 {
  font-size: 30px;
  letter-spacing: 0.6px;
  margin-bottom: 16px;
}
.updates-list {
  list-style-type: square;
  letter-spacing: 0.32px;
  font-family: "GeometriaLight";
}
.updates-list li::marker {
  color: #004ba0;
}
</style>
